import type { RouteRecordRaw } from "vue-router";

export const historiesRoutes: RouteRecordRaw[] = [
  {
    path: "/histories",
    name: "histories",
    component: () => import("./HistoryListPage.vue"),
    meta: {
      requiresAuth: true,
      title: "history.heading.title",
    },
  },
];
